export default __webpack_public_path__ + "static/media/banner-informations.ef938d93.png";